import { inject } from "vue-demi";
import { generateUrl as imgproxyGenerateUrl } from "@imgproxy/imgproxy-js-core";
import { getPath, isAbsoluteUrl, isNonProxySrc, isRelativeNonCdnImage } from "../utils.mjs";
import { DEFAULT_BASE_URL, DEFAULT_OPTIONS, PROVIDE_KEY, PROXY_PREFIX } from "../constants.mjs";
export default function useCdnImg() {
  const options = inject(PROVIDE_KEY);
  const baseUrl = options?.baseURL || DEFAULT_BASE_URL;
  function generateNonProxyUrl(src) {
    return isAbsoluteUrl(src) ? src : `${baseUrl}${src}`;
  }
  ;
  function generateProxyUrl(src, options2) {
    const imgproxyURL = imgproxyGenerateUrl(
      { value: getPath(src), type: "plain" },
      { ...DEFAULT_OPTIONS, ...options2 }
    );
    return `${baseUrl}${PROXY_PREFIX}${imgproxyURL}`;
  }
  ;
  const generateUrl = (src, options2) => {
    if (isRelativeNonCdnImage(src))
      return src;
    if (isNonProxySrc(src))
      return generateNonProxyUrl(src);
    return generateProxyUrl(src, options2);
  };
  return {
    generateUrl
  };
}
